export function transformNodeTagForm(formState) {
    return formState;
}
export function transformNodeTagData(_a) {
    var name = _a.name, values = _a.values;
    return { name: name, values: values };
}
